import React from "react";
import { Show, TabbedShowLayout, Tab, ShowProps } from "react-admin";

import AcademicTerm from "./AcademicTerm";
import TitleBreadcrumb from "components/TitleBreadcrumb";
import SanitizedGrid from "components/SanitizedGrid";
import { Grid } from "@material-ui/core";
import Holiday from "pages/academicYears/Holiday";
import CustomFormLabel from "components/CustomFormLabel";
import { GetParam } from "utils/tools";
import Summary from "./Summary";

const AcademicYearShow = (props: ShowProps) => {
  const param = GetParam();
  const { id } = props;

  const breadcrumb = [
    { title: "Schools", link: `/schools` },
    {
      link: `/schools/${param.get("schoolId")}/show/4`,
      title: "Academic Years",
    },
    {
      link: ``,
      title: id,
    },
  ];

  return (
    <>
      <TitleBreadcrumb paths={breadcrumb} />
      <CustomFormLabel property={props} isNoActions />
      <Show {...props} actions={false}>
        <SanitizedGrid container spacing={2}>
          <Grid item xs={12}>
            <TabbedShowLayout>
              <Tab label="Summary">
                <Summary {...props} />
              </Tab>
              <Tab label="Academic Term">
                <AcademicTerm {...props} />
              </Tab>
              <Tab label="Holiday">
                <Holiday {...props} />
              </Tab>
            </TabbedShowLayout>
          </Grid>
        </SanitizedGrid>
      </Show>
    </>
  );
};

export default AcademicYearShow;
